<ix-widget-datapoint
  *ixWithLoadingState="cpuModel$ as cpuModel"
  [size]="size()"
  [label]="name | translate"
  [text]="cpuModel"
></ix-widget-datapoint>
